module.exports = __webpack_public_path__ + "static/media/HAND.d24eb2ab.svg";